Array.prototype.indexOf || (Array.prototype.indexOf = function(e) {
        return jQuery.inArray(e, this)
    }),

    $.fn.inView = function() {
        var e = $(window);
        obj = $(this);
        var t = e.scrollTop(),
            i = e.scrollTop() + e.height(),
            a = obj.offset().top + 20;
        return i >= a && a >= t ? !0 : !1
    },

    $.fn.exists = function() {
        return $(this).length > 0 ? !0 : !1
    },

    $.fn.replaceImageWithOneOfNewSrc = function(e) {
        var t = $(this).clone().wrap("<div />").parent().html();
        t = t.replace(/(src=")([^"]*)/gi, "$1" + e);
        var i = $(t);
        return $(this).after(i).remove(), i
    },

    $.fn.fadeToAnotherImage = function(e, t) {
        var i = $(this),
            a = i.height(),
            o = !i.parent().hasClass("heightkeeper") && i.attr("src") != e;
        return o ? (i.wrap($('<div class="heightkeeper" />').css({
            height: a,
            overflow: "hidden"
        })).stop(!0, !0).animate({
            opacity: 0
        }, 200, function() {
            i = i.replaceImageWithOneOfNewSrc(e), i.imagesLoaded(function() {
                i.stop(!0, !0).animate({
                    opacity: 1
                }, 200), i.parent().stop(!0, !0).animate({
                    height: i.height()
                }, 500, function() {
                    i.unwrap(), t && t(i)
                })
            })
        }), !0) : !1
    },

    $.fn.fillWithShopifyProduct = function() {
        return $(this).each(function() {
            var e = $(this).data("fill-with-product"),
                t = $(this).find('script[type="text/template"]'),
                i = t.html();
            $.getJSON("/products/" + e + ".json", function(e) {
                var a = e.product;
                for (var o in a) i = i.replace(new RegExp("\\[" + o + "\\]", "ig"), a[o]);
                var r = a.image.src.lastIndexOf(".");
                i = i.replace(/\[img:([a-z]*)\]/gi, a.image.src.slice(0, r) + "_$1" + a.image.src.slice(r)), t.replaceWith(i)
            })
        })
    },

    window.selectCallback = function(e, t) {
        if (e)
            for (i = 0; i < e.options.length; i++) parseFloat(jQuery.fn.jquery) < 1.6 ? jQuery('.swatch[data-option-index="' + i + '"] :radio[value="' + e.options[i].replace(/"/g, "") + '"]').attr("checked", "checked") : jQuery('.swatch[data-option-index="' + i + '"] :radio[value="' + e.options[i].replace(/"/g, "") + '"]').prop("checked", !0);
        if (e)
            if (e.available) {
                if (e.compare_at_price > e.price) {

                    jQuery("#price").html('<del class="price_compare">' + Shopify.formatMoney(e.compare_at_price, window.money_format) + "</del>" + '<div class="price">' + Shopify.formatMoney(e.price, window.money_format) + "</div>")
                } else jQuery("#price").html('<div class="price">' + Shopify.formatMoney(e.price, window.money_format) + "</div>");
                 jQuery("#add").removeClass("disabled").removeAttr("disabled").html(jQuery("#add").data("addtocart")), e.inventory_management && e.inventory_quantity <= 0 ? (jQuery("#selected-variant").html(t.product.title + " - " + e.title), jQuery("#backorder").removeClass("hidden")) : jQuery("#backorder").addClass("hidden")
            } else jQuery("#backorder").addClass("hidden"), jQuery("#add").html(jQuery("#add").data("soldout")).addClass("disabled").attr("disabled", "disabled");
        else {
            var o = jQuery("#add").data("unavailable"),
                r = $(".selector-wrapper select").filter(function() {
                    return "" == $(this).val()
                }).length > 0;
            r && (o = jQuery("#add").data("addtocart")), jQuery("#price del").remove(), jQuery("#backorder").addClass("hidden"), jQuery("#add").html(o).addClass("disabled").attr("disabled", "disabled")
        }
        if (e && e.featured_image) {
            var n = Shopify.Image.removeProtocol(e.featured_image.src);
            $(".thumbnails a.thumbnail").filter('[href="' + n + '"]').trigger("click")
        }
        e && e.sku ? $("#sku").removeClass("hidden").find("span").html(e.sku) : $("#sku").addClass("hidden").find("span").html("")
    },

    jQuery(window).resize(function() {
        itgeeks.handleSticky(), itgeeks.detectOptions()
    }),

    $(window).scroll(function() {
        itgeeks.closeThemeControll2()
    }),

    jQuery(document).ready(function() {
        itgeeks.init(), jQuery("[data-fill-with-product]").fillWithShopifyProduct()
    });

var ctlCloseButton = '<a class="close-ctl" href="javascript:;" data-ctl-close><i class="fa fa-close"></i></a>',

    itgeeks = {
        timeout: null,
        init: function() {
            this.searchBarOpen(), this.detectOptions(), this.handleHomepage(),  this.productTab(), this.handleTabs(), this.handleSearch(), this.callbackSearchMobile(), this.handleMenuMobile(), this.handleCartSidebar(), this.handleSlideshow(), this.handleMap(), this.handleSmoothScroll(), this.closeThemeControllEvents(), this.handleEffects(), this.handleSticky(), this.handleQuickshop(), this.handleMore(), fakewaffle.responsiveTabs(["xs"])
        },
        handleMore: function() {
            $("#header_nav .top-bar-arrow").click(function() {
                var e = $(this);
                e.hasClass("act") ? ($(".site-right").slideDown(), $("#site-more").slideDown(), e.removeClass("act")) : ($("#site-more").slideUp(), $(".site-right").slideUp(), e.addClass("act"))
            })
        },
        searchBarOpen: function() {
            var searchOpen = $('#search-open');
            var headSearchClick = $('.search-click');
            var headSearchClickDismis = $('.search-close');
            headSearchClick.on('click', function() {
                searchOpen.addClass('searchopen');
            });
            headSearchClickDismis.on('click', function() {
                searchOpen.removeClass('searchopen');
            });
        },

        handleQuickshop: function() {
            function resizeColorBox() {
                resizeTimer && clearTimeout(resizeTimer), resizeTimer = setTimeout(function() {
                    $("#cboxOverlay").is(":visible") && ($.colorbox.resize({
                        width: $(window).width() > myWidth + 20 ? myWidth : Math.round($(window).width() * percentageWidth)
                    }), $(".cboxPhoto").css({
                        width: $("#cboxLoadedContent").innerWidth(),
                        height: "auto"
                    }), $("#cboxLoadedContent").height($(".cboxPhoto").height()), $.colorbox.resize())
                }, 300)
            }
            $(document).on("click", ".incrQty_quickview", function() {
             var jQueryinput = jQuery(".quinty_quickview");
             //alert('jQueryinput');
                  jQueryinput.val(parseInt(jQueryinput.val())+1);
              }),
               $(document).on("click", ".decQty_quickview", function() {
             var jQueryinputf = jQuery(".quinty_quickview");
             //alert('jQueryinputf');
            if (jQueryinputf.val()>=1)
                  jQueryinputf.val(parseInt(jQueryinputf.val())-1);
            
              }),
            jQuery.colorbox.settings.maxWidth = "95%", jQuery.colorbox.settings.width = "960px";
            var myWidth = 960,
                percentageWidth = .95,
                resizeTimer;
            $(window).resize(resizeColorBox), window.addEventListener("orientationchange", resizeColorBox, !1), itgeeks.isMobile() || ($(document).on("initzoom", ".product-gallery .main .main-img-link", function() {
                $(this).trigger("zoom.destroy"), $(this).zoom({
                    url: $(this).attr("href")
                })
            }), $(".product-gallery .main .main-img-link").trigger("initzoom")), $(document).on("initproduct", "#product-form", function() {
                var e = $(this).find("#product-select");
                if (1 == e.length) {
                    var t = ($(this).find(".product-form"), window.products["id" + $(this).data("product-id")]);
                    new Shopify.OptionSelectors(e.attr("id"), {
                        product: t,
                        onVariantSelected: selectCallback,
                        enableHistoryState: !1
                    }), t.available && t.options.length > 1 && Shopify.linkOptionSelectors(t), itgeeks.createVariantsSwatch(t, $(this)), 1 == t.variants.length && "Default Title" == t.variants[0].title && jQuery(".selector-wrapper").hide();
                    for (var i = !1, a = 0; a < t.variants.length; a++) {
                        var o = t.variants[a];
                        if (o.available && 0 == i) {
                            i = !0;
                            for (var r = 0; r < o.options.length; r++) $(".single-option-selector:eq(" + r + ")").val(o.options[r]).trigger("change")
                        }
                    }
                }
            }), $("#product-form").trigger("initproduct"), $(document).on("click", ".product-gallery .thumbnails .thumbnail", function(e) {
                e.preventDefault();
                var t = $(this).closest(".product-gallery"),
                    i = t.find(".main img.main-img");
                $(this).data("src") != i.attr("src") && t.find(".main .main-img-link").addClass("loader"), i.attr("alt", $(this).attr("title")).fadeToAnotherImage($(this).data("src"), function(e) {
                    e.closest(".main-img-link").removeClass("loader").trigger("initzoom"), t.closest(".quickbuy-form").length > 0 && $.colorbox.resize()
                }) && (t.find(".main .main-img-link").trigger("zoom.destroy").attr({
                    href: $(this).attr("href"),
                    title: $(this).attr("title")
                }), $(this).addClass("active").siblings(".active").removeClass("active"))
            }), $(document).on("click", ".quick-shop", function() {
                var $prod = $(this).closest(".product_item"),
                    prevIndex = $prod.index(".product_item") - 1,
                    nextIndex = $prod.index(".product_item") + 1;
                nextIndex > $prod.siblings(".product_item").length && (nextIndex = -1), eval($prod.find("[id^=product-block-json-]").html());
                var template = $prod.find("[id^=product-block-template-]").html();
                return $.colorbox({
                    onOpen: function() {
                        $("body").addClass("cbox-active")
                    },
                    onClosed: function() {
                        $("body").removeClass("cbox-active")
                    },
                    closeButton: !1,
                    html: ['<div class="action-icons">', '<a href="javascript:;" class="close-box action-icon"><span class="fa fa-close"></span></a>', "</div>", template].join(""),
                    onComplete: function() {
                        $("#product-form").trigger("initproduct"), $.colorbox.resize(), $(".quickbuy-form").imagesLoaded(function() {
                            $.colorbox.resize(), $(".product-gallery .main .main-img-link").trigger("initzoom")
                        }), $(".product-details .product-wishlist").html($prod.find(".product-buttons .product-wishlist").html())
                    }
                }), !1
            }), $(document).on("click", "#colorbox .action-icons .close-box", function() {
                return $.colorbox.close(), !1
            }).on("click", "#colorbox .action-icons .prev-item, #colorbox .action-icons .next-item", function() {
                return $(".product_item:eq(" + $(this).data("idx") + ") .quick-shop").click(), !1
            })
        },

        productTab: function() {
            // active first tab
            jQuery('.nav-tabs').each(function() {
                jQuery(this).find('li:first a').click();
            })
        },

        handleSticky: function() {
            if (jQuery("#header.sticky-header").length > 0) {
                var e = 0,
                    t = jQuery("#header_nav").css("height", "auto").outerHeight() + jQuery("#site-navigation").outerHeight(),
                    i = jQuery("#header_nav").css("height", "auto").outerHeight(),
                    a = window.innerWidth;
                a > 767 ? jQuery("#header_nav").css("height", i) : jQuery("#header_nav").css("height", "auto"), jQuery(window).scroll(function() {
                    var i = jQuery(this).scrollTop(),
                        a = window.innerWidth;
                    i > t && a > 767 ? (jQuery("#header_nav").addClass("is-sticky").removeClass("not-sticky"), jQuery("#site-navigation").addClass("fadeInDown")) : (jQuery("#header_nav").addClass("not-sticky").removeClass("is-sticky"), jQuery("#site-navigation").removeClass("fadeInDown"));
                    var o = jQuery(this).scrollTop(),
                        r = 800;
                var headerNav = $('#header_nav');
                var navWrapHeights = headerNav.children('.container').children('.navigation_wrapper').height();
                headerNav.attr('style', 'height:'+navWrapHeights+'px');

                })
            }
        },
        hoverIntent: function() {
            jQuery(".nav-dropdown-parent").hoverIntent(function() {
                var e = jQuery(this),
                    t = e.find(".nav-dropdown");
                t.slideDown(500, "jswing", function() {
                    e.addClass("active")
                })
            }, function() {
                var e = jQuery(this),
                    t = e.find(".nav-dropdown");
                t.slideUp(500, "jswing", function() {
                    e.removeClass("active")
                })
            })
        },
        handleEffects: function() {
            var e = $(".animated:not(.shown)");
            e.exists() && (setTimeout(function() {
                itgeeks.loadingEffects()
            }, 100), $(window).on("scroll", function() {
                itgeeks.loadingEffects()
            }))
        },
        loadingEffects: function() {
            var e = $(".animated:not(.shown)");
            e.exists() && itgeeks.precessEffects(e)
        },
        precessEffects: function(e) {
            var t = 0;
            e.each(function() {
                var e = $(this);
                $("html.touch").length > 0 ? e.hasClass("shown") || e.hasClass("animation-triggered") || (e.addClass("animation-triggered"), setTimeout(function() {
                    e.hasClass("animation-triggered") && e.removeClass("animation-triggered").addClass("shown")
                }, 200)) : e.hasClass("shown") || e.hasClass("animation-triggered") || !e.inView() || (e.addClass("animation-triggered"), t++, setTimeout(function() {
                    e.hasClass("animation-triggered") && e.removeClass("animation-triggered").addClass("shown")
                }, 100 * t))
            })
        },

        showModal: function(selector) {
            $(selector).fadeIn(500)
            itgeeks.ellaTimeout = setTimeout(function() {
                $(selector).fadeOut(500);
            }, 5000);
        },
        showThemeControll: function(e) {
            itgeeks.closeThemeControll(!0), jQuery(".theme-ctl.temp").remove();
            var t = jQuery(e);
            t.appendTo("body").addClass("reveal").find(".ctl-actions").remove(), t.prepend('<div class="ctl-actions">' + ctlCloseButton + "</div>"), itgeeks.isPageScrollin() && jQuery("#page, #site-control").css("padding-right", jQuery.scrollBarWidth()), jQuery("body").addClass("ctl-active")
        },
        showThemeControll2: function(e) {
            itgeeks.closeThemeControll2(!0);
            var t = jQuery(e);
            t.addClass("reveal2")
        },
        closeThemeControll: function() {
            clearTimeout(itgeeks.timeout), jQuery("a[data-ctl-toggle].active").removeClass("active"), jQuery(".theme-ctl.reveal").removeClass("reveal").addClass("unreveal"), jQuery("body").removeClass("ctl-active"), itgeeks.isPageScrollin() && jQuery("body").css("padding-right", 0)
        },
        closeThemeControll2: function() {
            clearTimeout(itgeeks.timeout), jQuery(".theme-ctl.reveal2").removeClass("reveal2")
        },
        closeThemeControllEvents: function() {
            jQuery(document).on("click", "body:not(.ctl-active) a[data-ctl-toggle]", function(e) {
                e.preventDefault();
                var t = jQuery(jQuery(this).data("ctl-toggle")).removeClass("unreveal").addClass("reveal");
                t.find(":input[type=search]:visible:first").focus(), jQuery(this).addClass("active"), itgeeks.isPageScrollin() && jQuery("body").css("padding-right", jQuery.scrollBarWidth()), jQuery("body").addClass("ctl-active")
            }).on("keyup", function(e) {
                27 == e.which && itgeeks.closeThemeControll()
            }), jQuery(document).on("click", "body.ctl-active a[data-ctl-close]", function(e) {
                e.preventDefault(), itgeeks.closeThemeControll()
            }), jQuery(document).on("click", ".theme-ctl", function(e) {
                e.target == this && (e.preventDefault(), itgeeks.closeThemeControll(), jQuery(this).trigger("reset-ctl"))
            }), jQuery(document).on("click", "body.ctl-active a[data-ctl-toggle]", function(e) {
                e.preventDefault(), itgeeks.closeThemeControll(), jQuery(this).click()
            }), jQuery(document).on("click", "a[data-ctl-target]", function(e) {
                e.preventDefault(), itgeeks.showThemeControll($('<div class="theme-ctl temp"/>').append($('<div class="inner"/>').html(jQuery(jQuery(this).data("ctl-target")).wrapInner('<div class="container"/>').html())))
            })
        },
        isPageScrollin: function() {
            return jQuery("#page").outerHeight() > jQuery(window).height()
        },

        buildProductItem: function() {
            jQuery("select.product-select").each(function(e) {
                var t = new Date,
                    i = t.getTime() + e;
                jQuery(this).attr("id", "product-select-" + i).attr("data-id", i)
            })
        },
        createVariantsSwatch: function(e, t) {
            var a = new Array;
            if (window.swatch_size && a.push("Size"), window.swatch_color && (a.push("Color"), a.push("Colour")), a.length > 0) {
                var o = ".png",
                    r = !1,
                    n = !1,
                    s = 0,
                    l = window.asset_url.substring(0, window.asset_url.lastIndexOf("?")),
                    d = window.asset_url.substring(window.asset_url.lastIndexOf("?"), window.asset_url.length);
                for (i = 0; i < e.options.length; i++) {
                    var c = "";
                    if (c = "object" == typeof e.options[i] ? e.options[i].name : e.options[i], r = !1, n = !1, a.indexOf(c) > -1) {
                        r = !0, s = i;
                        var u = c.toLowerCase();
                        if (/color|colour/i.test(u) && (n = !0), r) {
                            var h = "",
                                f = "";
                            /size/i.test(c.toLowerCase()) && window.size_chart && (f = '<a id="size_chart_trigger" href="#" class="sizechart-ctl" data-ctl-toggle="#sizechart-ctl">' + window.size_chart_txt + "</a>"), h += '<div class="swatch ' + u + ' clearfix" data-option-index="' + s + '">', h += '<div class="header"><span>' + c + "</span>" + f + "</div><div>";
                            var m = new Array;
                            for (j = 0; j < e.variants.length; j++) {
                                var p = e.variants[j],
                                    y = p.options[s],
                                    g = itgeeks.convertToSlug(y),
                                    v = "swatch-" + s + "-" + g;
                                m.indexOf(y) < 0 && (h += '<div data-value="' + y + '" class="swatch-element ' + (n ? "color" : "") + g + (p.available ? " available " : " soldout ") + '">', n && (h += '<div class="tooltip">' + y + "</div>"), h += '<input id="' + v + '" type="radio" name="option-' + s + '" value="' + y + '"' + (0 == j ? " checked " : "") + (p.available ? "" : " disabled") + "/>", n ? (h += '<label for="' + v + '" class="img"><i style="background-color:' + g + "; background-image: url(" + l + g + o + d + ')">', h += '<img class="crossed-out" src="' + l + 'soldout.png" />', h += "</i></label>") : (h += '<label for="' + v + '">' + y, h += '<img class="crossed-out" src="' + l + 'soldout.png" />', h += "</label>"), h += "</div>", m.push(y))
                            }
                            h += "</div></div>", t.find("#product-variants > select").after(h), t.find(".swatch :radio").change(function() {
                                var e = jQuery(this).closest(".swatch").attr("data-option-index"),
                                    t = jQuery(this).val();
                                jQuery(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")
                            })
                        }
                    }
                }
            }
        },
        convertToSlug: function(e) {
            return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        isMobile: function() {
            var e = navigator.userAgent.toLowerCase();
            return Modernizr.touch || e.match(/(iphone|ipod|ipad)/) || e.match(/(android)/) || e.match(/(iemobile)/) || e.match(/iphone/i) || e.match(/ipad/i) || e.match(/ipod/i) || e.match(/blackberry/i) || e.match(/bada/i) || e.match(/windows phone/i) || e.match(/webOS/i) ? !0 : !1
        },
        getWidthBrowser: function() {
            var e;
            return "number" == typeof window.innerWidth ? e = window.innerWidth : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? e = document.documentElement.clientWidth : document.body && (document.body.clientWidth || document.body.clientHeight) && (e = document.body.clientWidth), e
        },
        getHeightBrowser: function() {
            var e;
            return "number" == typeof window.innerHeight ? e = window.innerHeight : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? e = document.documentElement.clientHeight : document.body && (document.body.clientWidth || document.body.clientHeight) && (e = document.body.clientHeight), e
        },


        handleTabs: function() {
            jQuery("body").on("click", ".nav-tabs a", function(e) {
                e.preventDefault(), jQuery(this).tab("show")
            })
        },


        handleSlideshow: function() {

            $(".owl-carousel[data-carousel=owl]").each(function() {
                var config = {
                    loop: true,
                    nav: $(this).data('nav'),
                    dots: $(this).data('pagination'),
                    items: 1,
                    autoplay: 3e3,
                    autoHeight:true,
                    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
                };

                var owl = $(this);
                if ($(this).data('items')) {
                    config.items = $(this).data('items');
                }

               

                if ($(this).data('animatein')) {
                    config.animateIn = $(this).data('animatein');
                }
                if ($(this).data('animateOut')) {
                    config.animateOut = $(this).data('animateout');
                }
                if ($(this).data('autoplay')) {
                    config.autoplay = $(this).data('autoplay');
                }
                if ($(this).data('autoplaytimeout')) {
                    config.autoplayTimeout = $(this).data('autoplaytimeout');
                }
                $(this).owlCarousel(config);
            })


        },
        handleMap: function() {
            jQuery("#contact_map").length && jQuery().gMap && jQuery("#contact_map").gMap({
                zoom: window.contact_zoom,
                scrollwheel: window.contact_scroll,
                maptype: window.contact_type,
                markers: [{
                    address: window.contact_address,
                    html: "_address",
                    icon: {
                        image: window.contact_icon,
                        iconsize: [188, 68],
                        iconanchor: [0, 68]
                    }
                }]
            })
        },

        handleCartSidebar: function() {
            jQuery(".cart-controller").click(function(e) {
                e.stopPropagation(), jQuery(".cart-sidebar").toggleClass("opened"), jQuery("html,body").toggleClass("cart-opened")
            }), jQuery("#page").click(function() {
                jQuery(".cart-sidebar").removeClass("opened"), jQuery("html,body").removeClass("cart-opened")
            })
        },
        handleMenuMobile: function() {
            jQuery("#page").click(function() {
                jQuery(".menu-mobile").removeClass("opened"), jQuery("html,body").removeClass("menu-opened")
            }), jQuery("[data-toggle=offcanvas]").click(function(e) {
                e.stopPropagation(), jQuery(".menu-mobile").toggleClass("opened"), jQuery("html,body").toggleClass("menu-opened")
            }), jQuery(".is-mobile .menu-mobile .mobile_nav .expand").click(function() {
                var e = jQuery(this).parents(".parent_submenu").first();
                e.hasClass("is_open") ? e.removeClass("is_open") : e.addClass("is_open"), e.find(".dropdown_menu").first().slideToggle()
            })
        },
        handleSearch: function() {
            jQuery(".site-search-toggle").click(function() {
                var e = jQuery("#header");
                e.hasClass("is_search") ? e.removeClass("is_search") : (e.addClass("is_search"), jQuery("#input-ajax").focus())
            }), jQuery(".site-search-trigger").click(function() {
                jQuery(".search-menu-icon .site-search-toggle").trigger("click")
            })
        },

        callbackSearchMobile: function() {
            var e = jQuery(".is-mobile .is-mobile-search .fa-search"),
                t = jQuery(".is-mobile .is-mobile-search .fa-times"),
                i = jQuery(".is-mobile .is-mobile-search .input-search"),
                a = jQuery(".is-mobile .is-mobile-search");
            e.click(function() {
                a.addClass("on"), i.focus()
            }), i.click(function() {
                return !1
            }), t.click(function() {
                a.removeClass("on")
            })
        },


        handleSmoothScroll: function() {
            jQuery("body").on("click", ".smoothscroll", function(e) {
                e.preventDefault();
                var t = jQuery(this).attr("href");
                jQuery(t).trigger("click"), setTimeout(function() {
                    jQuery("html,body").animate({
                        scrollTop: jQuery("#product-reviews").offset().top - 100
                    }, 800, "swing")
                }, 300)
            })
        },

        detectOptions: function() {
            itgeeks.getWidthBrowser() < 992 ? jQuery("#product-header-first").is(":empty") && jQuery("#product-header").detach().appendTo("#product-header-first") : jQuery("#product-header-first").is(":empty") || jQuery("#product-header").detach().appendTo("#product-header-last")
        },

        handleHomepage: function() {
          
            $(".carousel-style-1[data-carousel=owlfeatured]").each(function() {
              var config = {
                 loop: !0,
                    rtl: window.rtl,
                    margin: 0,
                    nav: !0,
                    dots: !1,
                    mouseDrag: !0,
                    items: 5,
                    responsive: !0,
                    responsive: {
                        0: {
                            items: 1
                        },
                        479: {
                            items: 1
                        },
                        767: {
                            items: 3
                        },
                        992: {
                            items: $(this).data('noofproduct')
                        }
                    },
                    navText: ['<span class="btn-owl"><i class="fa fa-angle-left"></i></span>', '<span class="btn-owl"><i class="fa fa-angle-right"></i></span>']
    
              };
               $(this).owlCarousel(config);
              
              
            }),
                jQuery("#blog-slider").length && jQuery("#blog-slider").owlCarousel({
                    autoplay: true,
                    loop: !0,
                    margin: 0,
                    nav: !0,
                    dots: !1,
                    mouseDrag: !0,
                    autoplayTimeout: 3000,
                    items: 5,
                    responsive: !0,
                    responsive: {
                        0: {
                            items: 1
                        },
                        479: {
                            items: 1
                        },
                        767: {
                            items: 2
                        },
                        992: {
                            items: 2
                        }
                    },
                    navText: ['<span class="btn-owl"><i class="fa fa-angle-left"></i></span>', '<span class="btn-owl"><i class="fa fa-angle-right"></i></span>']
                }),
              jQuery("#megamenu_slider").length && jQuery("#megamenu_slider").owlCarousel({
                    loop: !0,
                    rtl: window.rtl,
                    margin: 0,
                    nav: !0,
                    dots: !1,
                    mouseDrag: !0,
                    items: 5,
                    responsive: !0,
                    responsive: {
                        0: {
                            items: 1
                        },
                        479: {
                            items: 1
                        },
                        767: {
                            items: 3
                        },
                        992: {
                            items: 4
                        }
                    },
                    navText: ['<span class="btn-owl"><i class="fa fa-angle-left"></i></span>', '<span class="btn-owl"><i class="fa fa-angle-right"></i></span>']
                }),
              jQuery("#product-offers-slider").length && jQuery("#product-offers-slider").owlCarousel({
                    autoplay: true,
                    loop: !0,
                    margin: 0,
                    nav: !0,
                    dots: !1,
                    mouseDrag: !0,
                    autoplayTimeout: 3000,
                    items: 5,
                    responsive: !0,
                    responsive: {
                        0: {
                            items: 1
                        },
                        479: {
                            items: 1
                        },
                        767: {
                            items: 2
                        },
                        992: {
                            items: 2
                        }
                    }, 
              			navText: ['<span class="btn-owl"><i class="fa fa-angle-left"></i></span>', '<span class="btn-owl"><i class="fa fa-angle-right"></i></span>']
                }),

              
           jQuery("#partner-slider").length && jQuery("#partner-slider").owlCarousel({
                    autoplay: true,
                    loop: !0,
                    margin: 0,
                    nav: !1,
                    dots: !1,
                    mouseDrag: !0,
                    autoplayTimeout: 3000,
                    items: 5,
                    responsive: !0,
                    responsive: {
                        0: {
                            items: 2
                        },
                        479: {
                            items: 3
                        },
                        767: {
                            items: 3
                        },
                        992: {
                            items: 6
                        }
                    },
                }),
              jQuery("#about-slider").length && jQuery("#about-slider").owlCarousel({
                    autoplay: true,
                    loop: !0,
                    margin: 0,
                    nav: !1,
                    dots: !0,
                    mouseDrag: !0,
                    autoplayTimeout: 3000,
                    items: 1,
                    responsive: !0,
                    responsive: {
                        0: {
                            items: 1
                        },
                        479: {
                            items: 1
                        },
                        767: {
                            items: 1
                        },
                        992: {
                            items: 1
                        }
                    },
             
                }),
              jQuery("#collection-sidebar").length && jQuery("#collection-sidebar").owlCarousel({
                     autoplay: true,
                    loop: !0,
                    margin: 0,
                    nav: !1,
                    dots: !0,
                    mouseDrag: !0,
                    autoplayTimeout: 3000,
                    items: 1,
                    responsive: !0,
                    responsive: {
                        0: {
                            items: 1
                        },
                        479: {
                            items: 1
                        },
                        767: {
                            items: 1
                        },
                        992: {
                            items: 1
                        }
                    },
            })
            

        }
    };

/* ================ SEARCH POPUP ==================== */


  	var searchpopup = $('.search-popup-box');
    var addClassess = $(".addClass");
    var removeClasses = $("#removeClass");
    var animatedPopup = $("#qnimate");
  
  if (searchpopup.length) {
        $(function() {
            addClassess.on('click', function() {
                animatedPopup.addClass('popup-box-on');
            });

            removeClasses.on('click', function() {
                animatedPopup.removeClass('popup-box-on');
            });
        })
    }

/* ================ FANCYBOX POPUP==================== */

var fancybox = $('.fancybox');

 if (fancybox.length) {
        fancybox.fancybox();
    }



/* ================ QUANTITY ==================== */

var addPlus = $('#addqtypro');
var removeMinus = $('#minusqtypro');  
  
addPlus.on('click', function() {
 
        var $qty = $(this).closest('ul').find('.qty');
        var currentVal = parseInt($qty.val(), 10);
        if (!isNaN(currentVal)) {
            $qty.val(currentVal + 1);
        }
    });
	
    removeMinus.on('click', function() {
        var $qty = $(this).closest('ul').find('.qty');
        var currentVal = parseInt($qty.val(), 10);
        if (!isNaN(currentVal) && currentVal > 0) {
            $qty.val(currentVal - 1);
        }
    });

 /* ================ FANCYBOX ==================== */

 

   var fancyboxImg = $('.fancybox');
    var fancyboxIframe = $('.fancybox-iframe');
  


    if (fancyboxImg.length) {
        fancyboxImg.fancybox();
    }
    if (fancyboxIframe.length) {
        fancyboxIframe.fancybox({
            type: "iframe",
            // other API options
        });
    }

 var videoPlayer = $('.video-section figcaption a');

  videoPlayer.on('click', function(e) {
        e.preventDefault();
        var newVideo = $(this).attr('href');
        $(this).parent('figcaption').parent('figure').parent('.video-section').addClass('active');
    });

   /* ================ SHOW AND HIDE ==================== */


$(function(){
  $('.hide-show').show();
  $('.hide-show span').addClass('show')
  
  $('.hide-show span').click(function(){
    if( $(this).hasClass('show') ) {
      $(this).text('Hide');
      $('input[name="customer[password]"]').attr('type','text');
      $(this).removeClass('show');
    } else {
       $(this).text('Show');
       $('input[name="customer[password]"]').attr('type','password');
       $(this).addClass('show');
    }
  });
	
	$('form button[type="submit"]').on('click', function(){
		$('.hide-show span').text('Show').addClass('show');
		$('.hide-show').parent().find('input[name="customer[password]"]').attr('type','password');
	}); 
});





 /* ================ home slider js ==================== */

			var tpj=jQuery;
			var revapi1014;
			tpj(document).ready(function() {
				if(tpj("#rev_slider_1014_1").revolution == undefined){
					
				}else{
					revapi1014 = tpj("#rev_slider_1014_1").show().revolution({
						sliderType:"standard",
						jsFileLocation:"revolution/js/",
						sliderLayout:"fullscreen",
						dottedOverlay:"none",
						delay:1500,
						navigation: {
							keyboardNavigation:"off",
							keyboard_direction: "horizontal",
							mouseScrollNavigation:"off",
 							mouseScrollReverse:"default",
							onHoverStop:"off",
							touch:{
								touchenabled:"on",
								swipe_threshold: 75,
								swipe_min_touches: 1,
								swipe_direction: "horizontal",
								drag_block_vertical: false
							}
							,
							arrows: {
								style:"uranus",
								enable:true,
								hide_onmobile:true,
								hide_under:480,
								hide_onleave:false,
								tmp:'',
								left: {
									h_align:"left",
									v_align:"center",
									h_offset:20,
									v_offset:0
								},
								right: {
									h_align:"right",
									v_align:"center",
									h_offset:20,
									v_offset:0
								}
							}
						},
						responsiveLevels:[1240,1024,778,480],
						visibilityLevels:[1240,1024,778,480],
						gridwidth:[1240,1024,778,480],
						gridheight:[868,768,960,600],
						lazyType:"none",
						shadow:0,
						spinner:"off",
						stopLoop:"on",
						stopAfterLoops:0,
						stopAtSlide:1,
						shuffle:"off",
						autoHeight:"off",
						fullScreenAutoWidth:"off",
						fullScreenAlignForce:"off",
						fullScreenOffsetContainer: "",
						fullScreenOffset: "60px",
						disableProgressBar:"on",
						hideThumbsOnMobile:"off",
						hideSliderAtLimit:0,
						hideCaptionAtLimit:0,
						hideAllCaptionAtLilmit:0,
						debugMode:false,
						fallbacks: {
							simplifyAll:"off",
							nextSlideOnWindowFocus:"off",
							disableFocusListener:false,
						}
					});
				}

               // RsTypewriterAddOn(tpj, revapi1014);
			});	

/* ================ product page slider ==================== */

     var prod_slider = $("#prod_slider");
  var slider_thumbnail = $("#slider_thumbnail");
  var slidesPerPage = 4; //globaly define number of elements per page
  var syncedSecondary = false;

  prod_slider.owlCarousel({
    items : 1,
    nav: true,
    autoplay: false,
    dots: false,
    loop: false,
    navText: ["<i class='revicon-angle-left'></i>","<i class='revicon-angle-right'></i>"],
  }).on('changed.owl.carousel', syncPosition);

  slider_thumbnail
    .on('initialized.owl.carousel', function () {
      slider_thumbnail.find(".owl-item").eq(0).addClass("current");
    })
    .owlCarousel({
    items : slidesPerPage,
    margin:10,
    dots: false,
    nav: false,
    slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
  }).on('changed.owl.carousel', syncPosition2);

  function syncPosition(el) {
    //if you set loop to false, you have to restore this next line
    var current = el.item.index;
    console.log(current);
    

    slider_thumbnail
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = slider_thumbnail.find('.owl-item.active').length - 1;
    var start = slider_thumbnail.find('.owl-item.active').first().index();
    var end = slider_thumbnail.find('.owl-item.active').last().index();
    
    if (current > end) {
      slider_thumbnail.data('owl.carousel').to(current, 100, true);
    }
    if (current < start) {
      slider_thumbnail.data('owl.carousel').to(current - onscreen, 100, true);
    }
  }
  
  function syncPosition2(el) {
    if(syncedSecondary) {
      var number = el.item.index;
      prod_slider.data('owl.carousel').to(number, 100, true);
    }
  }
  
  slider_thumbnail.on("click", ".owl-item", function(e){
    e.preventDefault();
    var number = $(this).index();
     prod_slider.data('owl.carousel').to(number, 300, true);
  });

 $('.currency-picker__wrapper select').change(function () {
         location.reload();
       });